import { useState, useEffect, useCallback } from 'react';

function useCountdown(startTimeInSeconds) {

    const [timeLeft, setTimeLeft] = useState(startTimeInSeconds);
    const [isRunning, setIsRunning] = useState(true);

    useEffect(() => {
        if (!isRunning) return;

        const timerId = setInterval(() => {
            setTimeLeft((prevTime) => prevTime - 1);
        }, 1000);

        return () => clearInterval(timerId);
    }, [isRunning]);

    const stopTimer = useCallback(() => {
        setIsRunning(false);
    }, []);

    const absTimeLeft = Math.abs(timeLeft);
    const hours = Math.floor(absTimeLeft / 3600);
    const minutes = Math.floor((absTimeLeft % 3600) / 60);
    const seconds = absTimeLeft % 60;

    return { hours, minutes, seconds, isNegative: timeLeft < 0, stopTimer };
}

export default useCountdown;
